$(document).on("turbolinks:load", () => {
  // on page reload browsers keep checkboxes checked
  $(".batch-action-checkbox:checked").parents("tr").addClass("selected");
});

// toggle checkbox on row click
$(document).on("click", ".prices-table td, .prices-table th", (e) => {
  const checkbox = $(e.target).parent("tr").find("input.batch-action-checkbox");
  const newState = !checkbox.prop("checked");
  checkbox.prop("checked", newState);
  checkbox.parents("tr").toggleClass("selected", newState);
});

$(document).on("change", ".check-all", (e) => {
  const checked = e.target.checked;
  $(".batch-action-checkbox").prop("checked", checked);
  $(".prices-table tr").toggleClass("selected", checked);
});

$(document).on("change", ".batch-action-checkbox", (e) => {
  let isAllChecked =
    $(".batch-action-checkbox:checked").length === $(".batch-action-checkbox").length;
  $(".check-all").prop("checked", isAllChecked);
  $(e.target).parents("tr").toggleClass("selected", e.target.checked);
});

$(document).on("click", ".delete-selected-prices", (e) => {
  e.preventDefault();
  e.stopPropagation();
  const priceIdsToDelete = [];
  $(".batch-action-checkbox:checked").map((index, checkbox) => {
    priceIdsToDelete.push(checkbox.id);
  });
  $.ajax({
    method: "DELETE",
    url: `/admin/prices/batch_delete`,
    dataType: "JSON",
    data: {
      selected: priceIdsToDelete,
    },
    success: () => {
      document.location.reload(true);
    },
  });
});
